import {Policy} from './policy.model';

export class GetPoliciesRequest {
  person_id: number;
  broker_id: number;
  product_type_id: number;
  policy_id: string;
  page_size = 10;
  page = 1;
  start = 0;
  brokerage_id: string;
  status: string;
  broker: string;
  product: string;
  search_query: string;
  sort_field: string; // Column name, or uw, etc
  sort_order: string; // Either asc or desc
}

export class GetPoliciesResponse {
  data: Policy[] = [];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
